export const TWILIO_ACCOUNT_SID_PATTERN = /^AC[0-9a-fA-F]{32}$/;
export const TWILIO_API_KEY_SID_PATTERN = /^SK[0-9a-fA-F]{32}$/;
export const TWILIO_MESSAGING_SERVICE_SID_PATTERN = /^MG[0-9a-fA-F]{32}$/;
export const SMS_SENDER_PHONE_NUMBER_PATTERN = /^\+[1-9][0-9]{6,14}$/;
export const SMS_SENDER_NAME_PATTERN = /^[A-Za-z0-9 +\-_&.]{1,11}$/;
export const SMS_SENDER_NAME_LETTER_PATTERN = /[A-Za-z]/;
export const MASKED_ACCOUNT_SID_PREFIX = 'AC••••';
